import { Slide } from '@/types';

export type ProjectNameSource = 'cover_auto' | 'manual' | 'legacy_topic';

const MAX_PROJECT_NAME_LENGTH = 60;

function stripMarkdown(text: string): string {
  return text
    .replace(/^#+\s*/gm, '')
    .replace(/\*\*(.*?)\*\*/g, '$1')
    .replace(/\*(.*?)\*/g, '$1')
    .replace(/__(.*?)__/g, '$1')
    .replace(/~~(.*?)~~/g, '$1')
    .replace(/`(.*?)`/g, '$1')
    .replace(/\[(.*?)\]\((.*?)\)/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}

function truncateName(text: string): string {
  if (text.length <= MAX_PROJECT_NAME_LENGTH) return text;
  return `${text.slice(0, MAX_PROJECT_NAME_LENGTH - 3).trim()}...`;
}

export function isLikelyUrlName(text?: string): boolean {
  if (!text) return false;
  const value = text.trim().toLowerCase();
  return value.startsWith('http://') || value.startsWith('https://') || value.startsWith('www.');
}

export function inferLegacyNameSource(name?: string): ProjectNameSource {
  const value = (name || '').trim();
  if (!value || value.startsWith('Carrossel ') || isLikelyUrlName(value)) {
    return 'legacy_topic';
  }
  return 'manual';
}

export function extractProjectNameFromCover(slides: Slide[]): string {
  const firstSlide = slides[0];
  if (!firstSlide?.content?.trim()) return '';

  const cleanContent = stripMarkdown(firstSlide.content);
  if (!cleanContent) return '';

  const firstSentence = cleanContent.split(/[.!?\n]/)[0]?.trim() || '';
  if (!firstSentence || isLikelyUrlName(firstSentence)) return '';

  return truncateName(firstSentence);
}
